import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'contracts',
  inputShow: gql`
    query contracts($input: ContractQueryInput) {
      contracts(input: $input) {
        id
      }
    }
  `,
  create: Create,
  edit: Edit,
  list: List,
  show: Show,
  options: {
    group: false,
  },
};
